<!-- <div class="pageStyle">
  <h1>Error</h1>
</div> -->

<div class="container">
  <div class="row">
      <div class="col-md-12">
          <div class="error-template">
              <h1>Oops!</h1>
              <div class="error-details">
                Sorry, something went wrong on our end. We are currently trying to fix the problem.
              </div>
              <div class="error-actions">
                  <a href="" class="btn btn-lg">Go Back Home</a>
              </div>
          </div>
      </div>
  </div>
</div>